<template>
  <div style="text-align: left">
    <div v-if="Object.keys(description).includes('autopay')">
      <h2>Autopay</h2>
      <p><strong>Status: </strong>{{description['autopay'] ? 'Enabled' : 'Disabled'}}</p>
      <p><strong>Changed By: </strong>{{description['changedBy']}}</p>
    </div>
    <div v-else-if="description['creditCardSigned']">
      <h2>Credit Card Signed</h2>
      <preview-pdf :source="description['creditCardSigned']" />
    </div>
    <div v-else-if="description['creditCardAdded']">
      <h2>Credit Card Added</h2>
      <el-descriptions label-style="font-weight: bold" v-for="(value, key) in description['creditCardAdded']" :key="key">
        <el-descriptions-item :label="key" v-if="filterRow(value)">
          {{value}}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else-if="description['previousEmail']">
      <h2>Updated Email</h2>
      <p><strong>Previous Email: </strong>{{description['previousEmail']}}</p>
      <p><strong>New Email: </strong>{{description['email']}}</p>
    </div>
  </div>
</template>

<script>
import PreviewPdf from './PreviewPdf.vue';

export default {
  name: 'Profile Changes',
  props: { note: { type: String, required: true } },
  components: { PreviewPdf },
  computed: {
    description() {
      if (!this.note) return {};

      return JSON.parse(this.note.description);
    }
  },
  methods: {
    filterRow(value) {
      if (typeof value === 'number') return true;
      else if (typeof value === 'string' && value !== 'Unknown') return true;

      return false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProfileChanges.vue